import type { WatchlistTranslation } from "./index";

export const italian = {
  title: "Insight",
  subtitle_team: "Monitora ciò che conta nel lavoro del tuo team e riprendi le analisi recenti.",
  subtitle_personal: "Monitora ciò che conta nel tuo lavoro e riprendi le analisi recenti.",
  create: "Crea",
  track_kpi: "Monitora un KPI",
  track_kpi_hint: "Segui qualcosa nel tempo",
  run_analysis: "Esegui un'analisi",
  run_analysis_hint: "Fai una domanda una tantum sui dati attuali",
  recent_analyses: "Analisi recenti",
  recent_analyses_empty: "Le domande che fai in questa sessione compaiono qui.",
  heading: "Chiedi qualsiasi cosa sui tuoi processi",
  setup_heading: "Cosa vuoi monitorare?",
  ask_placeholder: "Chiedi del lavoro del tuo team…",
  ask_another_placeholder: "Fai un'altra domanda…",
  recent_questions: "Conversazioni recenti",
  delete_chat: "Elimina chat",
  chat_deleted: "Chat eliminata",
  undo: "Annulla",
  dismiss_deleted_chat: "Chiudi l'avviso di eliminazione",
  keep_question_re_running: "Vuoi mantenere attiva questa domanda?",
  include_in_watchlist: "Aggiungi a Insight",
  direct_setup_prompt:
    "Monitora un KPI o osserva i cambiamenti — una domanda ricorrente, rieseguita a intervalli regolari",
  direct_setup_active: "Configurazione del Watch — definiamo l'ambito prima di salvarlo.",
  direct_setup_reviewing:
    "Configurazione del Watch in corso — potremmo fare delle domande di chiarimento.",
  setup_watch: "Configura un Watch",
  setup_placeholder: "Specifica cosa vuoi monitorare…",
  back_to_ask: "Torna a Chiedi",
  setup_continue: "Continua",
  setup_question_progress: "Domanda {{current}} di {{total}} (round {{round}})",
  setup_recommended: "Consigliato",
  setup_something_else: "Altro",
  setup_custom_placeholder: "Scrivi la tua risposta…",
  setup_back: "Indietro",
  setup_next: "Avanti",
  dismiss_keep_question: "Chiudi",
  watch_from_conversation: "Trasforma questa conversazione in una domanda ricorrente.",
  reviewing: "Controllo…",
  saved_and_running: "Salvato come “{{title}}” — in esecuzione",
  title_placeholder: "Dai un nome a questo avviso",
  all_processes: "Tutti i processi",
  all_people: "Tutte le persone",
  select_processes: "Seleziona processi",
  select_people: "Seleziona persone",
  scope_people: "{{count}} persone",
  scope_people_one: "{{count}} persona",
  scope_processes: "{{count}} processi",
  scope_processes_one: "{{count}} processo",
  window_last_n_days: "Ultimi {{count}} giorni",
  runs_weekly: "Esegui ogni settimana",
  runs_every_n_days_count: "Esegui ogni {{count}} giorni",
  every_n_days: "ogni {{count}} giorni",
  your_alerts: "Monitorati",
  kpis_tracking: "KPI che monitoro",
  filter_all: "Tutti",
  search_alerts: "Cerca avvisi e KPI…",
  no_matching_alerts: "Nessun avviso o KPI corrisponde a questi filtri.",
  no_alerts:
    "Ancora nulla di monitorato. Monitora un KPI per controllare una domanda periodicamente.",
  never_run: "Mai eseguito",
  chat_about_last_result: "Chatta sull'ultimo risultato",
  back_to_list: "Torna a Insight",
  back_to_chat: "Torna alla chat",
  view_in_watchlist: "Vedi in Insight",
  chat_empty_hint:
    "Non c'è ancora nulla da interrogare — registra e analizza il tuo lavoro, poi potrai farci domande qui.",
  rename_alert: "Rinomina avviso",
  latest_notification: "Ultima notifica",
  alert_edited_at: "Alert modificato · {{at}}",
  unread: "Non letto",
  suggestion_apps: "Quali app hanno consumato più tempo?",
  suggestion_manual_entry: "Tempo perso in inserimento dati manuale",
  suggestion_rework: "Quali passaggi vengono rifatti più spesso?",
  suggestion_outlier: "Chi esegue questo processo diversamente dagli altri?",
  suggestion_repetitive: "Qual è la cosa più ripetitiva che facciamo?",
  suggestion_automation: "Cosa si potrebbe automatizzare con il maggior beneficio?",
  running: "Attivo",
  run_now: "Esegui ora",
  run_in_progress: "In esecuzione",
  run_failed: "Esecuzione non riuscita",
  alert_actions: "Azioni avviso",
  delete_alert_title: "Eliminare l'avviso?",
  delete_alert_message:
    "Vuoi davvero eliminare “{{title}}”? Tutte le esecuzioni future verranno interrotte e l'azione non può essere annullata.",
  confirm_delete_alert: "Elimina avviso",
  delete_alert_failed: "Impossibile eliminare l'avviso",
  remove_from_scope: "Rimuovi dal contesto",
  days_back: "giorni indietro",
  days_between_runs: "giorni tra le esecuzioni",
} satisfies WatchlistTranslation;
